// extracted by mini-css-extract-plugin
export default {"root":"booking_category_column-module___root___f80a0ded"};